import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "../models/user.model";
import { HttpResponseHandlerService } from "./httpResponseHandler.service";
import { AppConstants } from "../app.constants";
import { HttpClient } from "@angular/common/http";
import { HttpModel } from "../models/http.model";
import { EUserType } from "../models/userInfo.model";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class RegistrationService {

  constructor(private http: HttpClient, private httpResponseHandlerService: HttpResponseHandlerService) {
  }

  generateRegistrationToken(email: string): Observable<boolean> {
    return this.http.post<HttpModel>(AppConstants.REGISTRATION_TOKEN_GENERATION, {email})
      .pipe(
        map((response) => this.httpResponseHandlerService.handlePostResponse(response, false)),
        catchError((error) => this.httpResponseHandlerService.handleError(error, true))
      );
  }

  confirmTokenAndRegister(user: User, token: string): Observable<boolean> {
    console.log(user);
    const userRegistrationRequest = {
      token,
      companyName: user.company,
      firstName: user["firstname"],
      lastName: user["lastname"],
      gender: user.gender,
      password: user.password,
      accountType: user.accountType,
      email: user.email,
      remark: user.remark,
      street: user.street,
      zip: user.zip,
      city: user.city,
      country: user.country,
      phone: user.phone,
      mobile: user.mobile
    };
    return this.http.post<HttpModel>(AppConstants.CONFIRM_TOKEN_AND_REGISTER, userRegistrationRequest)
      .pipe(
        map((response) => this.httpResponseHandlerService.handlePostResponse(response, false)),
        catchError((error) => this.httpResponseHandlerService.handleError(error, true))
      );
  }

  getAllCompaniesWithoutTestCompanies(): Observable<{ name: string, type: EUserType }[]> {
    return this.http.get<{ name: string, type: EUserType }[]>(AppConstants.GET_ALL_COMPANIES_WITHOUT_TEST)
      .pipe(
        map((response) => this.httpResponseHandlerService.handleGetResponse(response, false)),
        catchError((error) => this.httpResponseHandlerService.handleError(error))
      );
  }
}
